import ToastConstants from './ToastConsts';
let timeoutInstance = null;

export const disableToast = () => (dispatch) => {
    dispatch({ type: ToastConstants.DISABLE_TOAST })
    clearTimeout(timeoutInstance)
}

export const setToast = (type, message, timeout = 2000) => (dispatch) => {
    setTimeout(() => {
        dispatch({ type: ToastConstants.SET_TOAST, payload: { type, message, timeout } })
        timeoutInstance = setTimeout(() => {
            dispatch({ type: ToastConstants.DISABLE_TOAST })
        }, timeout)
    }, timeout)
}
